import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=63bc6256&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=ts&"
export * from "./Settings.vue?vue&type=script&lang=ts&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=63bc6256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc6256",
  null
  
)

export default component.exports